const formatTimeLabel = (time) => {
  if (!time || typeof time !== 'string') {
    return '';
  }
  const [hourPart, minutePart = '00'] = time.split(':');
  const hour = Number(hourPart);
  const minute = Number(minutePart);
  if (!Number.isFinite(hour) || !Number.isFinite(minute)) {
    return time;
  }
  const period = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 || 12;
  return `${hour12}:${String(minute).padStart(2, '0')} ${period}`;
};

export { formatTimeLabel };
